<template>
  <div class="common-sort-list">
    <span
      v-for="(item, index) in list"
      :key="index"
      :class="['other-sort-item', item.id === value ? 'active' : '']"
      @click="$emit('change', item.id)"
    >
      {{ item.text }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array
    },
    value: {
      type: [String, Number]
    }
  }
}
</script>

<style lang="scss">
.common-sort-list {
  display: flex;
  flex-wrap: nowrap;

  .other-sort-item {
    border-radius: 40px;
    margin-right: 30px;
    box-sizing: border-box;
    display: inline-block;
    padding: 18px 34px;

    background: #f3f4f5;
    font-size: 22px;
    color: #6c798c;

    font-family: PingFangSC-Regular;
    font-weight: 400;

    &:first-of-type {
      padding: 18px 28px;
    }
    &.active {
      color: #ffffff;
      background: #ff745b;
    }
  }
}
</style>
